var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-text",
      class: { edit: _vm.isSelected },
      on: { click: _vm.finish },
    },
    [
      _c(
        "div",
        {
          staticClass: "sticker sticker-text",
          style: {
            textAlign: `${_vm.stickerInstance.data.align}`,
          },
        },
        [
          _c("p", {
            ref: "textEditable",
            staticClass: "textarea",
            class: `${_vm.stickerInstance.data.font} ${_vm.stickerInstance.data.align}`,
            style: {
              fontSize: `${this.stickerInstance.data.fontSize / 16}em`, //`${0.9375 + ((this.stickerInstance.data.fontSize - 15) * 10)/16 / 10}em`,
              textAlign: `${_vm.stickerInstance.data.align}`,
              color:
                _vm.stickerInstance.data.background == "primary"
                  ? _vm.secondaryColor
                  : _vm.stickerInstance.data.color,
              backgroundColor:
                _vm.stickerInstance.data.background == "none"
                  ? ""
                  : _vm.stickerInstance.data.background == "secondary"
                  ? _vm.secondaryColor
                  : _vm.stickerInstance.data.color,
              boxShadow:
                _vm.stickerInstance.data.background == "none" || _vm.textEmpty
                  ? ""
                  : `
                    ${
                      _vm.stickerInstance.data.background == "secondary"
                        ? _vm.secondaryColor
                        : _vm.stickerInstance.data.color
                    } 0.4em 0px 0px 0.28em, 
                    ${
                      _vm.stickerInstance.data.background == "secondary"
                        ? _vm.secondaryColor
                        : _vm.stickerInstance.data.color
                    } -0.4em 0px 0px 0.28em, 
                    ${
                      _vm.stickerInstance.data.background == "secondary"
                        ? _vm.secondaryColor
                        : _vm.stickerInstance.data.color
                    } 0px 0px 0px 0.28em
                `,
            },
            attrs: { contenteditable: _vm.isSelected, spellcheck: "false" },
            domProps: { innerHTML: _vm._s(_vm.models.textFormat) },
            on: {
              input: _vm.handlerInput,
              focus: _vm.handlerOnFocus,
              blur: _vm.handlerOnBlur,
            },
          }),
        ]
      ),
      _c("div", { staticClass: "container-cursor-size" }, [
        _c("div", { staticClass: "cursor-size" }, [
          _c("input", {
            attrs: { type: "range", min: "0", max: "350" },
            domProps: {
              value: String((_vm.stickerInstance.data.fontSize - 15) * 10),
            },
            on: { input: _vm.cursorChange },
          }),
          _c(
            "svg",
            {
              attrs: {
                width: "auto",
                height: "auto",
                viewBox: "0 0 80 794",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M40 793L1 1H79L40 793Z",
                  fill: "#CBCBCD",
                  stroke: "#CBCBCD",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "container-action" }, [
        _c("div", { staticClass: "list-option" }, [
          _vm.actionSelected == "font"
            ? _c(
                "div",
                {
                  staticClass: "list-option-text hide-scrollbar",
                  on: { wheel: _vm.handleHorizontalScroll },
                },
                [
                  _c(
                    "div",
                    { staticClass: "texts" },
                    _vm._l(
                      [
                        "modern",
                        "classic",
                        "signature",
                        "editor",
                        "poster",
                        "bubble",
                        "deco",
                        "squeeze",
                        "typewriter",
                        "strong",
                        "meme",
                        "elegant",
                        "directional",
                        "literature",
                      ],
                      function (font) {
                        return _c(
                          "div",
                          {
                            key: font,
                            class: [
                              "text",
                              font,
                              `${font}-font`,
                              {
                                active:
                                  _vm.stickerInstance.data.font ===
                                  `${font}-font`,
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeFont(`${font}-font`)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  font.charAt(0).toUpperCase() + font.slice(1)
                                ) +
                                "\n                    "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              )
            : _vm.actionSelected == "color"
            ? _c("div", { staticClass: "list-option-color" }, [
                _c("div", { staticClass: "pipette" }, [
                  _c(
                    "div",
                    {
                      staticClass: "icon",
                      style: { backgroundColor: _vm.pickerColors.hex },
                      on: {
                        click: () => {
                          _vm.stickerInstance.data.color = _vm.pickerColors.hex
                          _vm.colorPickerShow = true
                          _vm.showPipette = true
                        },
                      },
                    },
                    [
                      _vm.colorPickerShow
                        ? _c(
                            "div",
                            {
                              staticClass: "picker-color",
                              on: {
                                mouseleave: function ($event) {
                                  _vm.colorPickerShow = false
                                },
                                mousedown: function ($event) {
                                  _vm.showPipette = false
                                },
                              },
                            },
                            [
                              _vm.eyeDropperIsAccess && _vm.showPipette
                                ? _c("div", {
                                    staticClass: "icon-pipette",
                                    on: {
                                      mousedown: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.startEyeDropper.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("chrome-picker", {
                                attrs: { value: _vm.pickerColors },
                                on: { input: _vm.updateFromPicker },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "color-carousel" },
                  [
                    _c(
                      "carousel",
                      {
                        attrs: {
                          perPage: 1,
                          adjustableHeight: true,
                          centerMode: true,
                        },
                        on: { pageChange: () => {} },
                      },
                      _vm._l(
                        [
                          [
                            "#FFFFFF",
                            "#000000",
                            "#4397EF",
                            "#70C04F",
                            "#F6CB5B",
                            "#F08C34",
                            "#EA4857",
                            "#D12D69",
                            "#B100C0",
                          ],
                          [
                            "#EA3323",
                            "#ED858E",
                            "#F7D0D1",
                            "#FADAB4",
                            "#F5C281",
                            "#D18E47",
                            "#99643A",
                            "#432324",
                            "#1D4A29",
                          ],
                          [
                            "#262626",
                            "#363636",
                            "#555555",
                            "#737373",
                            "#999999",
                            "#B2B2B2",
                            "#C7C7C7",
                            "#DBDBDB",
                            "#EFEFEF",
                          ],
                        ],
                        function (colors, index) {
                          return _c(
                            "Slide",
                            { key: index },
                            _vm._l(colors, function (colorHexa) {
                              return _c("div", {
                                staticClass: "color",
                                style: `background-color:${colorHexa}`,
                                on: {
                                  click: () => {
                                    _vm.stickerInstance.data.color = colorHexa
                                    _vm.pickerColors.hex = colorHexa
                                  },
                                },
                              })
                            }),
                            0
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "list-action" }, [
          _c(
            "div",
            {
              staticClass: "action font",
              class: { active: _vm.actionSelected == "font" },
              on: {
                click: function ($event) {
                  _vm.actionSelected = "font"
                },
              },
            },
            [_c("div", { staticClass: "icon" })]
          ),
          _c(
            "div",
            {
              staticClass: "action color",
              class: { active: _vm.actionSelected == "color" },
              on: {
                click: function ($event) {
                  _vm.actionSelected = "color"
                },
              },
            },
            [_c("div", { staticClass: "icon" })]
          ),
          _c(
            "div",
            {
              staticClass: "action align",
              class: `${_vm.stickerInstance.data.align}`,
              on: {
                click: function ($event) {
                  _vm.stickerInstance.data.align = {
                    center: "start",
                    start: "end",
                    end: "center",
                  }[_vm.stickerInstance.data.align]
                },
              },
            },
            [_c("div", { staticClass: "icon" })]
          ),
          _c(
            "div",
            {
              staticClass: "action background",
              class: `${_vm.stickerInstance.data.background}`,
              on: {
                click: function ($event) {
                  _vm.stickerInstance.data.background = {
                    secondary: "primary",
                    primary: "none",
                    none: "secondary",
                  }[_vm.stickerInstance.data.background]
                },
              },
            },
            [_c("div", { staticClass: "icon" })]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }